(function(){
    'use strict';

    angular
    .module('appauth')
    .controller('RegistroController', RegistroController)
 
    RegistroController.$inject = ['RegistroService',"$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function RegistroController(RegistroService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 
        vm.real_username = "";
        vm.real_password = "";
        vm.datosToSetRegistro = {
            username:"",
            password:"",
            password2:"",
            nombre_clinica:"",
            pais_id:"",
            flexCheckDefault:false
        }
        vm.paises = {};
        console.log("PRUEBNA");
        vm.pruebame = function() {
            var myForm = document.getElementById('login-form');
            myForm.submit()
        }
        vm.getPaises = function(formReg){
            console.log('called getPaises', formReg);

            RegistroService.getPaises(function(response){
                console.log('response getPaises', response)
                vm.paises =response.paises;
            })
        }

        vm.registrarse = function(formReg){
            console.log('called registrarse', formReg);
            vm.real_username = vm.datosToSetRegistro.username;
            vm.real_password = vm.datosToSetRegistro.password;
            RegistroService.setRegistro(vm.datosToSetRegistro,function(response){
                console.log('response setRegistro getPrueba', response);
                
                // TODO @AL comprobaciones de que todo fue bien
                if (response.created_user && angular.isDefined(response.created_userapp[0])){
                    var myForm = document.getElementById('login-form');
                    myForm.submit()
                } else {
                    vm.real_username = '';
                    vm.real_password = '';
                }
            })
        }
    } 
  
})();